import * as Actions from '../../actions/app'

const initialState = {
  loading_product_mobility: false,
  product_mobility: [],
  total_product_mobility: 0,
  loading_product_stocks: false,
  product_stocks: [],
  loading_product_series: false,
  product_series: [],
  series_mobility: [],
  downloading_product_mobility: false,
  loading_suppliers_by_product: false,
  suppliers_by_product: [],
}

const productMobilityReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_PRODUCT_MOBILITY: {
      return {
        ...state,
        loading_product_mobility: action.payload.loading,
        product_mobility: action.payload.items ?? state.product_mobility,
        total_product_mobility: action.payload.total ?? state.total_product_mobility,
      }
    }

    case Actions.RESET_PRODUCT_MOBILITY: {
      return {
        ...state,
        loading_product_mobility: action.payload.loading,
        product_mobility: action.payload.items,
        total_product_mobility: action.payload.total,
      }
    }

    case Actions.DOWNLOADING_PRODUCT_MOBILITY: {
      return {
        ...state,
        downloading_product_mobility: action.payload,
      }
    }

    case Actions.GET_PRODUCT_STOCKS: {
      return {
        ...state,
        loading_product_stocks: action.payload.loading,
        product_stocks: action.payload.items ?? state.product_stocks,
      }
    }

    case Actions.GET_PRODUCT_SERIES: {
      return {
        ...state,
        loading_product_series: action.payload.loading,
        product_series: action.payload.items ?? state.product_series,
      }
    }

    case Actions.GET_SERIES_MOBILITY: {
      return {
        ...state,
        series_mobility: action.payload.items ?? state.series_mobility,
      }
    }

    case Actions.GET_SUPPLIERS_BY_PRODUCT: {
      return {
        ...state,
        loading_suppliers_by_product: action.payload.loading,
        suppliers_by_product: action.payload.data ?? state.suppliers_by_product,
      }
    }

    default: {
      return state
    }
  }
}

export default productMobilityReducer
